import { render, staticRenderFns } from "./AbilityChart.vue?vue&type=template&id=470d0cec&scoped=true"
import script from "./AbilityChart.vue?vue&type=script&lang=ts"
export * from "./AbilityChart.vue?vue&type=script&lang=ts"
import style0 from "./AbilityChart.vue?vue&type=style&index=0&id=470d0cec&prod&lang=css"
import style1 from "./AbilityChart.vue?vue&type=style&index=1&id=470d0cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d0cec",
  null
  
)

export default component.exports